<template>
	<div :class="[companyClass, canScroll]" v-loading="pageLoading" element-loading-text="Loading..."
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
		v-show="userPermissionsFilter.userstransactionsreports">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<div class="page-header">
				<h1 class="pageTitle">Customers Not Transacting</h1>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>reports</el-breadcrumb-item>
					<el-breadcrumb-item>customer transactions</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="toolbar-box flex">
				<div class="flex box grow">
					<el-select v-model="search" @change="refreshCompanies"
						placeholder="Select Customer Status in Dropdown">
						<el-option value="0" label="All">All</el-option>
						<el-option value="1" label="Transacting Customers">Transacting</el-option>
						<el-option value="2" label="Customers Not Transacting">Not Transacting</el-option>
					</el-select>
					<!--<el-date-picker type="date" placeholder="Transactions To" v-model="todate" format="dd-MMMM-yyyy" value-format="yyyy-MM-dd" :picker-options="{disabledDate: disableAllDatesAfterToday}"
                            v-validate="'required'"  @blur="refreshCompanies"
                            data-vv-as="end date" :disabled="readOnlyMode"></el-date-picker>-->
				</div>
			</div>

			<resize-observer @notify="handleResize" />
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Mobile</th>
							<th>Email</th>
							<th>Reg Date</th>
							<th>Doc Type</th>
							<th>Doc Number</th>
							<th>kycConfirmation</th>
							<th>approver</th>
							<th>Registration Platform</th>
							<th>KYC Platform</th>
							<th>comments</th>
							<th>Kyc Date</th>
							<th>Paid</th>
							<th>Amount Sent</th>
							<th>Pending</th>
							<th>Failed</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in transactionsdata" :key="item.customerNumber">
							<td>{{ item.firstName }}</td>
							<td>{{ item.lastName }}</td>
							<td>{{ item.phoneNumber }}</td>
							<td>{{ item.email }}</td>
							<td>{{ formatShortDate(item.registredOn) }}</td>
							<td>{{ item.documentType }}</td>
							<td>{{ item.idNumber }}</td>
							<td>{{ item.kycConfirmation }}</td>
							<td>{{ item.approver }}</td>
							<td>{{ item.registrationPlatform }}</td>
							<td>{{ item.kYCPlatform }}</td>
							<td>{{ item.comments }}</td>
							<td>{{ formatShortDate(item.createdOn) }}</td>
							<td>{{ parseInt(item.successTransactions) }}</td>
							<td>{{ formatPrice(item.totalAmount) }}</td>
							<td>{{ parseInt(item.pendingTransactions) }}</td>
							<td>{{ parseInt(item.failedTransactions) }}</td>
						</tr>
					</tbody>
				</table>
			</div>

		</div>
	</div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';

import users from '@/assets/data/USERS_MOCK_DATA.json'
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'Customers',
	data: function () {
		return {
			transactionsdata: '',
			search: '0',
			//IdProfile = "data:image/png;base64," + response.data;
		}
	},
	methods: {
		refreshCompanies() {
			this.startLoader("Loading Page...");
			this.getCustomers(this.search)
				.then((result) => {
					$("#datatable").dataTable().fnDestroy();
					this.transactionsdata = result.items;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		initDt() {
			var cmp = this.loggedInCompany.name + " Customer Transactions";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				dom: 'Blfrtip',
				"columnDefs": [
					{ "orderable": true, "targets": [11] }, // Column 1 is sortable
					{ "orderable": true, "targets": [13] }, // Column 2 is sortable
					{ "orderable": true, "targets": [14] }  // Column 3 is sortable
				],
				buttons: [
					{
						extend: 'pdfHtml5',
						title: function () {
							return cmp;
						},
						orientation: 'landscape',
						pageSize: 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
						customize: function (doc) {
							doc.defaultStyle.fontSize = 11; //2, 3, 4,etc
							doc.styles.tableHeader.fontSize = 10; //2, 3, 4, etc
							//doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
						},
						text: '<i class="fa fa-file-pdf-o"> PDF</i>',
						titleAttr: 'PDF',
						messageBottom: 'This report was generated By ' + this.loggedInUser,
					}
				]
			});
		},
		print(row) {
			//router.push(`/updatecompany/${row.id}`);
		},
	},
	created() {

	},
	mixins: [PermissionsMixins]
}
</script>
<style>
.table thead tr,
.table .tbody,
.table .tbody tr {
	white-space: nowrap;
}

.table thead tr th {
	padding: 5px 17px;
	padding-left: 5px;
	background-color: #1b1f27;
	font-weight: bold;
	color: rgba(255, 255, 255, 0.4);
}

table.dataTable tbody tr {
	background-color: #191d24;
}

table.dataTable {
	margin-left: 0px;
	text-align: left;
}

.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
	color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
	color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
	color: white !important;
}
</style>